module.exports = __webpack_public_path__ + "static/media/webinar-ms624-01.04c080b4.jpg";